export default {
  LOW_VALUE: 100,
  MEDIUM_VALUE: 500,
  HIGH_VALUE: 1000,
};
